import React from "react";
import TypeWriter from "react-typewriter";

const GridBackground = () => {
  return (
    <div className="grid-background">
      <svg
        className="grid-svg"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="smallGrid"
            width="100"
            height="100"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 100 0 L 0 0 0 100"
              fill="none"
              stroke="rgba(255, 255, 255, 0.15)"
              strokeWidth="0.75"
            />
          </pattern>

          <radialGradient id="spotGradient1" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(218, 165, 32, 0.15)" />
            <stop offset="100%" stopColor="rgba(218, 165, 32, 0)" />
          </radialGradient>

          <radialGradient id="spotGradient2" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(255, 215, 0, 0.1)" />
            <stop offset="100%" stopColor="rgba(255, 215, 0, 0)" />
          </radialGradient>

          <radialGradient id="spotGradient3" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(245, 191, 66, 0.12)" />
            <stop offset="100%" stopColor="rgba(245, 191, 66, 0)" />
          </radialGradient>
        </defs>

        {/* Changed the background color here */}
        <rect width="100%" height="100%" fill="#2b2b2b" />
        <rect width="100%" height="100%" fill="url(#smallGrid)" />

        <circle cx="50%" cy="80%" r="350" fill="url(#spotGradient3)" />
        <circle cx="75%" cy="20%" r="250" fill="url(#spotGradient1)" />
        <circle cx="30%" cy="65%" r="280" fill="url(#spotGradient2)" />
      </svg>
      <div className="gradient-overlay"></div>
    </div>
  );
};

const Header = ({ data }) => {
  if (data) {
    var name = data.name;
    var occupation = data.occupation;
    var description = data.description;
    var networks = data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            {network.name !== "Devpost" && network.name !== "Google Scholar" ? (
              <i className={network.className}></i>
            ) : (
              <div className="devpost-icon group">
                <img
                  height={32}
                  width={32}
                  src={network.className}
                  alt={`${network.name} icon`}
                  className="group-hover:hidden"
                />
                {/* Add hover state image */}
                <img
                  height={32}
                  width={32}
                  alt={`${network.name} icon`}
                  src={network.hoverClassName || network.className} // Use hoverClassName if provided, fallback to regular className
                  className="hidden group-hover:block"
                />
              </div>
            )}
          </a>
        </li>
      );
    });
  }

  return (
    <header id="home" className="relative">
      <GridBackground />
      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Hide navigation
        </a>
        <ul id="nav" className="nav">
          <li className="current">
            <a className="smoothscroll" href="#home">
              Home
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#resume">
              Experience
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#portfolio">
              Projects
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#contact">
              Contact
            </a>
          </li>
        </ul>
      </nav>
      <div className="row banner flex items-center justify-center flex-col">
        <div className="banner-text w-full flex flex-col items-center justify-around">
          <h1 className="responsive-headline text-5xl">
            <TypeWriter typing={0.8}>
              {name ? `Hi, I'm ${name}.` : null}
            </TypeWriter>
          </h1>
          <h3>
            <span>{occupation}</span>. {description}.
          </h3>
          <ul className="social flex flex-row items-center justify-around w-1/4">
            {networks}
          </ul>
        </div>
      </div>
      <p className="scrolldown">
        <a className="smoothscroll" href="#resume">
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </header>
  );
};

export default Header;
